import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import chevLeft from 'icons/chevron-left-24.png';
import { resultingClientExists } from 'workbox-core/_private';
import HelpTitle from 'components/common/HelpTitle';

export default function Notifications() {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  console.log('Notifications');

  navigator.setAppBadge(42).then(() => {
    console.log("The badge was added");
    }).catch(e => {
    console.error("Error displaying the badge", e);
    });

  function periodicEventRegistered() {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.periodicSync.getTags().then((tags) => {
          if (tags.includes("process-latest-event")) {
            console.log('process-latest-event is registered')
          } else {
            console.log('process-latest-event NOT registered', tags)
          }
        });
      })
      .catch((err) => {
        console.log('registration check error', err);
      });
  }

  async function registerPeriodicEvent() {
    const registration = await navigator.serviceWorker.ready;
    const pc = registration.periodicSync;
    pc.minInterval = 1000;
    console.log('register', registration, pc);
    registration.periodicSync.register("process-latest-event", {
        minInterval:  60 * 1000,
      })
      .then((res) => {
        console.log('then', res);
      })
      .catch((err) => {
      console.log("Periodic Sync could not be registered!");
      console.log(err);
    });
  }

  async function unregisterPeriodicEvent() {
    const registration = await navigator.serviceWorker.ready;
    console.log(registration);
    try {
      if ('periodicSync' in registration) {
        await registration.periodicSync.unregister('process-latest-event');
        console.log("Periodic Sync unregistered!");
      }    
    } catch(err) {
      console.log("Periodic Sync could not be unregistered!");
      console.log(err);
    }
  }

  function notify() {
    console.log('notify');
    if (!('serviceWorker' in navigator )) {
      console.log('No serviceWorker in navigator!');
      return;
    }
    const actions = [
      {
        action: 'Take',
        title: 'Take',
        icon: 'logo192.png'
      },
      {
        action: 'Snooze',
        title: 'Snooze',
        icon: 'logo192.png'
      },
      {
        action: 'Skip',
        title: 'Skip',
        icon: 'logo192.png'
      }
    ];
   
    navigator.serviceWorker.ready
      .then((swreg) => {
        console.log('got SW', swreg);
        let options = {
          body: 'Time to take ATENOLOL',
          data: 'This is some data',
          dir: 'ltr',
          actions: actions,
          icon: 'https://app.itookitwhen.com/logo512.png'
        };

        options.actions.push({ action: 'Skip', title: 'Skip', icon: 'logo192.png' });
        swreg.showNotification('I Took It When', options)
          .then((result) => {
            console.log('showNotification', result);
            setMessage('Notified');
          })
          .catch((err)=>{
            console.log('Subscription error: ', err);
            setMessage(err);
          });
        })
      .catch( (err) => {
        console.log('notification error', err);
        setMessage('Subscribe error ' + err);
      });

  };

  function getNotifications() {
    console.log("Notification", Notification);
    navigator.serviceWorker.ready
      .then((swreg) => {
        console.log('SW ready', swreg);
        swreg.getNotifications()
        .then((notes) => {
          console.log('notifications', notes);
        })
      })
      .catch((err) => {
        console.log('notifications error: ', err);
      })
  }

  function askPermission() {
    Notification.requestPermission()
      .then((result) => {
      console.log('Permission Choice', result);
      if (result !== 'granted') {
        console.log('Notification permission NOT granted!');
        setMessage('Permission NOT granted');
      } else {
        console.log('Notification permission granted!');
        setMessage('Permission granted');
      }
    });
  };

  //periodicEventRegistered();

  return (
    <div className='pt-8 flex flex-col justify-normal items-center h-full text-center font-bold text-2xl bg-blue-200 '>
      <HelpTitle title="Notifications" helpSubject="Notifications" />
      <div className='w-8/12 flex flex-col justify-center item-center mt-10 text-xl'>
        <button className='selBtn mb-4' onClick={askPermission}>Permission</button>
        <button className='selBtn mb-4' onClick={notify}>Notify!</button>
        <button className='selBtn mb-4' onClick={periodicEventRegistered}>Check Registration</button>
        <button className='selBtn mb-4' onClick={registerPeriodicEvent}>Register</button>
        <button className='selBtn mb-4' onClick={unregisterPeriodicEvent}>Unregister</button>
        <button className='selBtn mb-4' onClick={getNotifications}>Get Notifications</button>
        {message}
      </div>
    </div>
  )
}
